/**
 * Kann an Attributen, Attributgruppen oder Elementen eingesetzt werden um Sichbarkeit zu steuern.
 * 
 * Dazu werden dem Attribute/Element/der Attributgruppe Tags condColumn,condValue,condRule,condPath ausgewertet
 * 
 * = condRule, condColumn, condValue =
 * "condRule" bestimmt, wie der Wert von "condColumn" und der Wert "condValue" verglichen werden. Er ist defaultmässig „eq“. Es kann folgende Werte annehmen:
 *
 *  - eq: Es wird auf Gleichheit verglichen
 *  - ne: Es wird auf Ungleichheit verglichen
 *  - ge: Der Wert aus dem "condValue" ist größer oder gleich dem aktuellen Wert aus dem Datenmodell.
 *  - gt: Der Wert aus dem "condValue" ist größer dem aktuellen Wert aus dem Datenmodell.
 *  - le: Der Wert aus dem "condValue" ist kleiner oder gleich dem aktuellen Wert aus dem Datenmodell.
 *  - lt: Der Wert aus dem "condValue" ist kleiner dem aktuellen Wert aus dem Datenmodell.
 *  - in: "condValue" ist kommasepariert und darf vor und nach den Kommata, sowie zu Beginn und am Ende keine Leerzeichen enthalten, da ein reiner Textvergleich gemacht wird; richtig also bspw. "1,2,3"
 *        Die Bedingung trifft zu, wenn der Wert aus dem Datenmodell in der Liste enthalten ist
 *  - notin: "condValue" ist kommasepariert und darf vor und nach den Kommata, sowie zu Beginn und am Ende keine Leerzeichen enthalten, da ein reiner Textvergleich gemacht wird; richtig also bspw. "1,2,3"
 *        Die Bedingung trifft zu, wenn der Wert aus dem Datenmodell nicht in der Liste enthalten ist
 * = condPath = 
 * Mit "condPath" kann ausgehend vom dataElement ein Pfad der Form "../../OtherTag" vorgegeben werden in dem das Vergleichsattribut gesucht wird
 * 
 * @param {import('./Attribute').default | import('./Element').default | import('./AttributeGroup').default} metaElement von Attribut/Element/Attributgruppe
 * @param {import('../xmlrdb-data/DataElement').default} dataElement Datenelement, dessen Daten ausgewertet werden sollen.
 * @returns true/false: Trifft die Bedingung zu?
 */
export function OnValueOfAttribute (metaElement, dataElement) {
  const condPath= metaElement.tagValueByName("condPath");
  if (condPath) {
    for (let p of condPath.split("/")) {
      p = p.trim();               
      if (p === '..') dataElement = dataElement.parent;
      else if (p !== '.') dataElement = dataElement._[p];
      if (!dataElement) throw `Invalid path condPath "${condPath}" in OnValueOfAttribute: Step "${p}" yields no dataElement `
    }
  }
  metaElement.name()
  let condColumn = metaElement.tagValueByName("condColumn");
  if (!condColumn && Object.prototype.hasOwnProperty.call(dataElement.attributes, metaElement.name())) {
    condColumn = metaElement.name();
  }
  if (!condColumn) throw `In VisibilityFunction 'OnValueOfAttribute' fehlt die condColumn-Angabe`
  const condRule  = metaElement.tagValueByName("condRule")??"eq";
  const currentValue = dataElement.$[condColumn];
  const condValue = metaElement.tagValueByName("condValue");

  function isEqual() {
    if (dataElement.attributes[condColumn].metadata.type() == "bool")
      return condValue == "true" ? currentValue : !currentValue;
    else if (currentValue===null && condValue==="") // null == "" -> true, weil condValue über rdbxml als leerer String kommt
      return true;
    else
      return condValue  == currentValue ;
  }

  switch(condRule) {
    case "eq": return isEqual();
    case "ne": return !isEqual();
    case "ge": return condValue  >= currentValue ;
    case "gt": return condValue  > currentValue ;
    case "le": return condValue  <= currentValue ;
    case "lt": return condValue  < currentValue ;
    case "in": return !!condValue.split(",").find(e => e == currentValue);
    case "notin": return !condValue.split(",").find(e => e == currentValue);
    case "notnull": return currentValue !== null;
    default: throw `Unknown operator ${condRule} in OnValueOfAttribute-Visibility-Function. (condColumn: ${condColumn}; condValue:${condValue}`
  }            
   
}

export function NotOnValueOfAttribute (metaElement, dataElement) {
  return !OnValueOfAttribute(metaElement, dataElement);
}

export default {
  OnValueOfAttribute,
  NotOnValueOfAttribute
}